import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import {
  Dialog,
  DialogContent,
} from '../components/ui/dialog';
import { 
  Shield, 
  FileText, 
  HardHat, 
  Stethoscope, 
  Truck, 
  Factory, 
  Briefcase, 
  Store, 
  Heart,
  Building2,
  Users,
  Landmark,
  X
} from 'lucide-react';

const SpecializationsPage = () => {
  const navigate = useNavigate();
  const [selectedSpec, setSelectedSpec] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const specializations = [
    { 
      title: 'Property & Casualty', 
      subtitle: 'Small/Mid-Market',
      icon: Shield, 
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
      slug: 'property-casualty',
      description: 'Property and casualty insurance has been a primary focus for Archon Insurance. We provide comprehensive coverage options for small to mid-sized businesses across Massachusetts.',
      description2: 'Archon Insurance understands the unique risks faced by businesses in our region. We work with you to explore insurance and risk management options relevant to your specific industry and needs.'
    },
    { 
      title: 'Construction Risk', 
      subtitle: 'Solutions',
      icon: HardHat, 
      image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80',
      slug: 'construction-risk',
      description: 'Construction has been a primary focus for Archon Insurance. Innovative risk management programs, practical guidance, tailored coverage options, and responsive service for construction projects – it\'s the level of support you can expect from a broker who listens.',
      description2: 'Archon Insurance understands the risks associated with construction projects. While adequate coverage is important, managing costs and helping mitigate potential exposures are key priorities. We work with you to explore insurance and risk management options relevant to your construction business.'
    },
    { 
      title: 'Healthcare Risk', 
      subtitle: 'Solutions',
      icon: Stethoscope, 
      image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800&q=80',
      slug: 'healthcare-risk',
      description: 'Professionals in the healthcare field face unique risks, with critical decisions and careful oversight affecting daily operations.',
      description2: 'Archon Healthcare Risk Solutions provides insurance programs, resources, and educational materials designed to help healthcare organizations and medical professionals explore risk management options and make informed decisions.'
    },
    { 
      title: 'Transportation Risk', 
      subtitle: 'Solutions',
      icon: Truck, 
      image: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=800&q=80',
      slug: 'transportation-risk',
      description: 'The transportation industry faces unique challenges and exposures that require specialized insurance solutions and risk management expertise.',
      description2: 'Archon Insurance provides comprehensive transportation insurance programs designed to protect trucking companies, logistics providers, and fleet operators throughout Massachusetts and beyond.'
    },
    { 
      title: 'Manufacturing', 
      subtitle: '& Industrial',
      icon: Factory, 
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80',
      slug: 'manufacturing',
      description: 'Manufacturing operations face complex risks from product liability to equipment breakdown. Our specialized programs address these unique challenges.',
      description2: 'Archon Insurance works closely with manufacturers to develop comprehensive risk management strategies that protect your operations, products, and employees while helping control costs.'
    },
    { 
      title: 'Professional', 
      subtitle: 'Services',
      icon: Briefcase, 
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80',
      slug: 'professional-services',
      description: 'Professional service firms face unique liability exposures that require specialized coverage and expert guidance.',
      description2: 'Archon Insurance provides tailored professional liability solutions for accountants, attorneys, consultants, and other service professionals who need to protect their expertise and reputation.'
    },
    { 
      title: 'Retail', 
      subtitle: '& Hospitality',
      icon: Store, 
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80',
      slug: 'retail-hospitality',
      description: 'Retail and hospitality businesses require comprehensive coverage that addresses customer-facing risks and operational challenges.',
      description2: 'Archon Insurance understands the fast-paced nature of retail and hospitality operations. We provide insurance solutions that keep your business protected while maintaining focus on customer service.'
    },
    { 
      title: 'Non-Profit', 
      subtitle: 'Organizations',
      icon: Heart, 
      image: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=800&q=80',
      slug: 'non-profit',
      description: 'Non-profit organizations face unique risks while working to fulfill their missions and serve their communities.',
      description2: 'Archon Insurance provides specialized coverage for non-profits, including directors and officers liability, volunteer coverage, and programs designed for organizations with limited budgets but important missions.'
    },
    { 
      title: 'Real Estate', 
      subtitle: 'Risk Solutions',
      icon: Building2, 
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
      slug: 'real-estate',
      description: 'Real estate professionals and property owners face unique liability exposures and property risks that require specialized coverage.',
      description2: 'Archon Insurance provides comprehensive real estate insurance programs for property owners, managers, and real estate professionals throughout Massachusetts.'
    },
    { 
      title: 'Employee', 
      subtitle: 'Benefits',
      icon: Users, 
      image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&q=80',
      slug: 'employee-benefits',
      description: 'Attracting and retaining top talent requires competitive employee benefits packages that meet the needs of today\'s workforce.',
      description2: 'Archon Insurance helps businesses design and implement employee benefits programs that provide meaningful coverage while managing costs and ensuring compliance with regulations.'
    },
    { 
      title: 'Financial Institutions', 
      subtitle: 'Risk Solutions',
      icon: Landmark, 
      image: 'https://images.unsplash.com/photo-1501167786227-4cba60f6d58f?w=800&q=80',
      slug: 'financial-institutions',
      description: 'Financial institutions face complex regulatory requirements and unique liability exposures that demand specialized insurance expertise.',
      description2: 'Archon Insurance provides comprehensive coverage solutions for banks, credit unions, investment advisors, and other financial service providers operating in an increasingly regulated environment.'
    },
    { 
      title: 'Enterprise Insurance', 
      subtitle: 'for Small Business',
      icon: FileText, 
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
      slug: 'small-business',
      description: 'Small businesses need affordable, comprehensive coverage that protects their operations without breaking the budget.',
      description2: 'Archon Insurance offers streamlined insurance solutions for small businesses and startups, making it easy to get the coverage you need with competitive rates and flexible options.'
    },
  ];

  const handleCardClick = (spec) => {
    setSelectedSpec(spec);
    setIsModalOpen(true);
  };

  const handleLetUsHelp = () => {
    setIsModalOpen(false);
    navigate(`/contact-business-insurance?specialization=${encodeURIComponent(selectedSpec.title + ' - ' + selectedSpec.subtitle)}`);
  };

  const handleLearnMore = () => {
    setIsModalOpen(false);
    navigate(`/specializations/${selectedSpec.slug}`);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Page Banner */}
      <div className="page-banner">
        <div className="container-wide">
          <h1>AREAS OF SPECIALIZATION</h1>
          <div className="breadcrumb">
            <Link to="/">Home</Link> &gt; Areas of Specialization
          </div>
        </div>
      </div>

      {/* Content */}
      <section className="py-12" data-testid="specializations-content">
        <div className="container-wide">
          
          <h2 className="text-3xl font-serif text-[#1a365d] mb-8">Choose Business Sector</h2>
          
          {/* Specializations Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {specializations.map((spec, index) => (
              <div 
                key={index}
                onClick={() => handleCardClick(spec)}
                className="group relative block overflow-hidden no-underline cursor-pointer"
                data-testid={`spec-card-${index}`}
              >
                {/* Background Image */}
                <div 
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-300 group-hover:scale-105"
                  style={{ 
                    backgroundImage: `url(${spec.image})`,
                    filter: 'grayscale(30%)'
                  }}
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
                
                {/* Content Card */}
                <div className="relative z-10 p-6 min-h-[200px] flex flex-col items-center justify-center">
                  {/* White Card */}
                  <div className="bg-white/95 backdrop-blur-sm rounded px-6 py-5 text-center shadow-lg w-full max-w-[200px]">
                    <spec.icon className="h-10 w-10 mx-auto mb-3 text-[#1a365d]" strokeWidth={1.5} />
                    <h3 className="font-serif text-[#1a365d] text-lg leading-tight mb-1">
                      {spec.title}
                    </h3>
                    {spec.subtitle && (
                      <p className="font-serif text-[#1a365d] text-lg leading-tight">
                        {spec.subtitle}
                      </p>
                    )}
                    <button className="mt-4 bg-[var(--gold)] text-white text-xs font-bold uppercase tracking-wider px-6 py-2 hover:bg-[var(--gold-dark)] transition-colors">
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Pop-up Modal - Matching Starshep.com Style */}
      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
        <DialogContent className="sm:max-w-xl p-0 overflow-hidden bg-white" data-testid="specialization-modal">
          {/* Close Button */}
          <button 
            onClick={() => setIsModalOpen(false)}
            className="absolute right-3 top-3 z-20 bg-black/50 hover:bg-black/70 rounded-full p-1 transition-colors"
            data-testid="modal-close-btn"
          >
            <X className="h-5 w-5 text-white" />
          </button>

          {/* Banner Image */}
          {selectedSpec && (
            <>
              <div 
                className="w-full h-40 bg-cover bg-center"
                style={{ backgroundImage: `url(${selectedSpec.image})` }}
              />
              
              {/* Content */}
              <div className="p-6 text-center">
                {/* Icon + Title */}
                <div className="flex items-center justify-center gap-3 mb-4">
                  <selectedSpec.icon className="h-8 w-8 text-[var(--gold)]" strokeWidth={1.5} />
                  <h2 className="text-2xl font-serif text-[#1a365d]">
                    {selectedSpec.title} {selectedSpec.subtitle}
                  </h2>
                </div>
                
                {/* Description Paragraphs */}
                <p className="text-[var(--text-dark)] mb-4 text-left leading-relaxed">
                  {selectedSpec.description}
                </p>
                <p className="text-[var(--text-dark)] mb-6 text-left leading-relaxed">
                  {selectedSpec.description2}
                </p>
                
                {/* CTA Text */}
                <p className="text-[var(--text-medium)] italic mb-4">
                  Ready to talk about {selectedSpec.title} Risks?
                </p>
                
                {/* Buttons */}
                <div className="flex items-center justify-center gap-3">
                  <button
                    onClick={handleLetUsHelp}
                    className="bg-[var(--gold)] text-white py-2 px-6 text-sm font-bold uppercase tracking-wider hover:bg-[var(--gold-dark)] transition-colors"
                    data-testid="modal-let-us-help-btn"
                  >
                    Let Us Help
                  </button>
                  
                  <button
                    onClick={handleLearnMore}
                    className="bg-[#1a365d] text-white py-2 px-6 text-sm font-bold uppercase tracking-wider hover:bg-[#0f2744] transition-colors"
                    data-testid="modal-learn-more-btn"
                  >
                    Learn More
                  </button>
                </div>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>

      <Footer />
    </div>
  );
};

export default SpecializationsPage;
